import { render, staticRenderFns } from "./FormControlTypeImage.vue?vue&type=template&id=505652ec&scoped=true"
import script from "./FormControlTypeImage.vue?vue&type=script&lang=js"
export * from "./FormControlTypeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505652ec",
  null
  
)

export default component.exports